import { ReconciliationIncosistentStateError } from "@common/contracts/reconciliation.contract";
import { getAnonymousAccountNumber } from "@common/helpers/bankAccount";
import { fullDateLongFormat } from "@common/helpers/date";
import { FinancialAccount } from "@common/types/financialAccount";
import { ErrorToast } from "@design-system/ToastMessages/ErrorToast";
import { format, parseISO } from "date-fns";

interface Props {
    error: ReconciliationIncosistentStateError;
    reconciliedFinancialAccount: FinancialAccount;
}

export const ReconciliationIncosistentStateErrorToast = ({
    error,
    reconciliedFinancialAccount,
}: Props) => {
    const accountLabel = `${reconciliedFinancialAccount.institutionName} ${getAnonymousAccountNumber(reconciliedFinancialAccount.accountNumberMask ?? "", 2)}`;

    const expectedStartDate = parseISO(error.expectedStartDate);
    const receivedEndDate = parseISO(error.receivedEndDate);

    return (
        <ErrorToast>
            <div>
                Statements for wrong dates uploaded for{" "}
                <strong>{accountLabel}</strong>. Reconciling from{" "}
                <strong>{format(expectedStartDate, fullDateLongFormat)}</strong>{" "}
                but received statements ending on{" "}
                <strong>{format(receivedEndDate, fullDateLongFormat)}</strong>.
            </div>
        </ErrorToast>
    );
};
